import { CartDiscountType } from '@grandvisionhq/fun-products';

const MAX_QUANTITY_LIMIT = 99;
const getDiscountPerPack = (packPrice, discountAmount, type, priceIsCentAmount)=>{
    if (type === CartDiscountType.PERCENT) {
        const discount = packPrice * discountAmount / 100;
        return Math.round(discount);
    }
    if (priceIsCentAmount) {
        const discount = discountAmount * 100;
        return Math.round(discount);
    }
    return Math.round(discountAmount);
};
const getCartDiscountAmount = (packPrice, appliedDiscounts)=>{
    let totalDiscountAmount = 0;
    if (appliedDiscounts) {
        for (const appliedDiscount of appliedDiscounts){
            if (appliedDiscount.discount.minimumQuantity > 0) {
                const cartDiscountPerPackAmount = getDiscountPerPack(packPrice, appliedDiscount.discount.amount, appliedDiscount.discount.type, true);
                const netDiscountAmount = cartDiscountPerPackAmount * appliedDiscount.timesApplied * appliedDiscount.discount.minimumQuantity;
                totalDiscountAmount += netDiscountAmount;
            }
        }
    }
    return totalDiscountAmount;
};
function getTotalAvailableQuantity(config) {
    const { leftEyeChecked , rightEyeChecked  } = config;
    let availableQuantity = 0;
    const totalAvailableQuantityLeft = getAvailableQuantity(config.maxOrderableQuantity);
    const totalAvailableQuantityRight = getAvailableQuantity(config.maxOrderableQuantity);
    if (leftEyeChecked) {
        availableQuantity += totalAvailableQuantityLeft;
    }
    if (rightEyeChecked) {
        availableQuantity += totalAvailableQuantityRight;
    }
    return availableQuantity;
}
function getFilteredQuantityDiscounts(config) {
    const { quantityDiscountItems  } = config;
    const totalAvailableQuantity = getTotalAvailableQuantity(config);
    if (!quantityDiscountItems) {
        return [];
    }
    return [
        ...quantityDiscountItems
    ].filter((item)=>item.minimumQuantity <= totalAvailableQuantity
    );
}
function getMatchedDiscounts(quantity, config) {
    const orderedQuantityDiscounts = getOrderedQuantityDiscounts(config);
    const matchedDiscounts = [];
    for (const discount of orderedQuantityDiscounts){
        if (quantity >= discount.minimumQuantity) {
            const timesApplied = Math.floor(quantity / discount.minimumQuantity);
            matchedDiscounts.push({
                discount,
                timesApplied
            });
            quantity -= timesApplied * discount.minimumQuantity;
        }
    }
    return matchedDiscounts;
}
function getHighestMatchedDiscount(quantity, config) {
    const discounts = getMatchedDiscounts(quantity, config);
    if (!discounts || discounts.length === 0) {
        return undefined;
    }
    const highestDiscount = discounts.reduce((prevDiscount, currDiscount)=>{
        return prevDiscount && prevDiscount.discount.minimumQuantity > currDiscount.discount.minimumQuantity ? prevDiscount : currDiscount;
    }, discounts[0]);
    return highestDiscount;
}
/**
 *
 * This function aims to divide an input number as evenly as possible into two parts, with one part possibly being slightly larger than the other if the input number is odd.
 * For example, if the input number is 5, the output will be [3, 2].
 * If the input number is 6, the output will be [3, 3].
 *
 * We use this to apply  the correct number of boxes to each eye when the user selects a discount item.
 */ function divideEvenlyInTwo(num) {
    return [
        Math.ceil(num / 2),
        Math.floor(num / 2)
    ];
}
function getAvailableQuantity(maxOrderableQuantity) {
    return maxOrderableQuantity ? Math.min(maxOrderableQuantity, MAX_QUANTITY_LIMIT) : MAX_QUANTITY_LIMIT;
}
function sortByMinimumQuantityDescending(a, b) {
    return b.minimumQuantity - a.minimumQuantity;
}
function sortByMinimumQuantityAscending(a, b) {
    return a.minimumQuantity - b.minimumQuantity;
}
function getOrderedQuantityDiscounts(config) {
    return getFilteredQuantityDiscounts(config).sort(sortByMinimumQuantityDescending);
}

export { divideEvenlyInTwo, getCartDiscountAmount, getDiscountPerPack, getFilteredQuantityDiscounts, getHighestMatchedDiscount, getMatchedDiscounts, getTotalAvailableQuantity, sortByMinimumQuantityAscending, sortByMinimumQuantityDescending };
//# sourceMappingURL=cart-discounts.js.map
